"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.16674 2.5L1.66675 5M18.3334 5L15.8334 2.5M5.00008 15.8333L3.33341 17.5M15.0001 15.8333L16.6667 17.5M10.0001 7.49999V10.8333L11.6667 12.5M10.0001 17.5C11.7682 17.5 13.4639 16.7976 14.7141 15.5474C15.9643 14.2971 16.6667 12.6014 16.6667 10.8333C16.6667 9.06521 15.9643 7.36952 14.7141 6.11928C13.4639 4.86904 11.7682 4.16666 10.0001 4.16666C8.23196 4.16666 6.53627 4.86904 5.28603 6.11928C4.03579 7.36952 3.33341 9.06521 3.33341 10.8333C3.33341 12.6014 4.03579 14.2971 5.28603 15.5474C6.53627 16.7976 8.23196 17.5 10.0001 17.5Z",
    stroke: fill,
    strokeWidth: "1.66666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;